import { Injectable } from '@angular/core';
import { Subject, interval } from 'rxjs';

import { ILoaderState } from '../../interfaces/loader.interface';

@Injectable()

/**
 * Inicialización de la clase ILoaderState, modelo para la configuración de los estados de carga de la aplicación
 *
 * *Set ILoaderState class, loading config states model*
 *
 * @access public
 * @type {class}
 */
export class LoaderService {

  /**
   * Instancia de loaderSubject como Subject<ILoaderState>
   *
   * *Sets loaderSubject instance as SubjectILoaderState>*
   *
   * @access private
   *
   * @type {Subject<ILoaderState>()} loaderSubject
   */
  private loaderSubject = new Subject<ILoaderState>();

  /**
   * Inicialización de loaderState as Observable
   *
   * *Sets loader state as observable*
   *
   *  @param {Observable} loaderState
   */
  loaderState = this.loaderSubject.asObservable();

  private pendingRequest: string[] = [];

  loaderSubscribe: any;

  /**
   * Activa el estado de carga y muestra el mensaje de los parámetros
   *
   * *Turns up loading state and shows the message from the parameters*
   *
   *  @param {string} msg
   */
  show(url: string, msg?: string) {
    this.pendingRequest.push(url);
    this.loaderSubject.next({ show: true, msg } as ILoaderState);
  }

  /**
   * Desactiva el estado de carga
   *
   * *Turns off loading state*
   */
  hide(url: string) {
    const index = this.pendingRequest.indexOf(url);
    if (index !== -1) {
      this.pendingRequest.splice(index, 1);
    }
    if (!this.pendingRequest.length) {
      this.loaderSubject.next({ show: false } as ILoaderState);
    }
  }
  forceHide() {
    this.pendingRequest = [];
    this.loaderSubject.next({ show: false } as ILoaderState);
  }
}
